import React from "react";
import './SingleReviewButtons.scss'
import {CircularProgress, Grid, IconButton, Tooltip} from "@mui/material";
import {AcceptButtons} from "./AcceptButtons";
import {CheckCircle, Error} from "@mui/icons-material";
import {ReviewChoice} from "../../../../services/classes/MaterializedClasses";
import {PartRowState} from "../../classes/PartRowState";
import {observer} from "mobx-react-lite";
import {AuthorChip} from "../../../taxonomy-editor/approval/component/AuthorChip";

type Props = {
    onAccept?: () => void
    part: PartRowState // TODO CAT-1580: Duplicate information is being shared here, violating mobx principles
}
/**
 * TODO CAT-1580: this component is not properly separating visual and control logic
 */
export const SingleReviewButtons: React.FC<Props> = observer(({onAccept, part}) => {
    const state = part.combinedStateVisual;
    const viewOnly = !part.combinedStateVisual.reviewAllowed;
    const isAccept = state.reviewChoice === ReviewChoice.ACCEPT;
    const isError = part.isError;

    let tooltipText: string | undefined = undefined
    if (isError) {
        tooltipText = 'Something went wrong'
    } else {
        if (state.approvalState === 'PENDING') {
            tooltipText = "Cannot accept already pending changes"
        } else if (state.approvalState === 'APPROVED') {
            tooltipText = "Cannot accept already approved changes"
        } else if (viewOnly) {
            tooltipText = "Review is not possible"
        } else {
        }
    }

    return <Grid container alignItems="center" justifyContent="space-evenly" className="single-review-buttons">
        <Grid item>
            {part.isLoading
                ? <CircularProgress size={14}/>
                : <Tooltip title={tooltipText} arrow>
                    {isError
                        ? <Error color="error"/>
                        : !state.isHidden
                            ? <span>
                                <AcceptButtons
                                    isAccept={isAccept}
                                    onAccept={viewOnly ? undefined : onAccept}
                                    disabled={state.isHidden}
                                />
                            </span>
                            : <span>
                                <IconButton className="disabled" disabled>
                                    <CheckCircle/>
                                </IconButton>
                            </span>
                    }
                </Tooltip>
            }
        </Grid>
        <Grid item>
            {part.data.review_user_id &&
                <AuthorChip
                    authorId={part.data.review_user_id}
                    onlyIcon
                    tooltipTemplate="Reviewed by {fullName}"
                />
            }
        </Grid>
    </Grid>
})
